module.exports = __webpack_public_path__ + "img/_ic_arrow_dyn_pos.c017b918.svg";